import { INSTRUCTIONS_MAX } from '../instructions';

export const AGENT_DESCRIPTION_MAX = 400;
export const AGENT_SYSTEM_MAX = INSTRUCTIONS_MAX;

export function normalizeAgentNewlines(value) {
  return String(value ?? '').replace(/\r\n?/g, '\n');
}

export function clampAgentText(value, max) {
  return normalizeAgentNewlines(value).slice(0, max);
}
